import React from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import {
    StyledClose,
    StyledContent,
    StyledOverlay,
    StyledTrigger,
    Form,
    Header,
    SectionBox,
    SendButton,
    SendButtonContainer,
    TitleHeader,
    AiFillCloseCircleIcon,
    FaUserEditIcon
} from './styles';

import { FormEvent, useState } from 'react';

import { IClientProps } from '../../../interfaces';


interface IUpdateClientProps {
    onClientUpdated: (client: IClientProps) => void,
    client : IClientProps
}

const UpdateClient: React.FC<IUpdateClientProps> = ({ onClientUpdated, client }: IUpdateClientProps) => {

    const [nome, setNome] = useState<string>(client.nome);
    const [dominio, setDominio] = useState<string>(client.dominio);
    const [webhookBitrix, setWebhookBitrix] = useState<string>(client.webhook);
    const [bitrixId, setBitrixId] = useState<string>(client.idList);
    const [jiraMain, setJiraMain] = useState<string>(client.jiraMain);
    const [jiraSupport, setJiraSupport] = useState<string>(client.jiraSupport);

    function handleSubmitButton(event: FormEvent) {
        event.preventDefault();

        onClientUpdated({
            dominio: dominio,
            idList: bitrixId,
            jiraMain: jiraMain,
            jiraSupport: jiraSupport,
            nome: nome,
            webhook: webhookBitrix,
            id: client.id
        });
    }

    return (
        <Dialog.Root>
            <StyledTrigger>
                <FaUserEditIcon />
            </StyledTrigger>

            <Dialog.Portal>
                <StyledOverlay />
                <StyledContent>
                    <StyledClose>
                        <AiFillCloseCircleIcon />
                    </StyledClose>

                    <Header>
                        <TitleHeader>
                            {client.nome}
                        </TitleHeader>
                    </Header>
                    <Form>
                        <SectionBox>
                            <label htmlFor="clientName">
                                Nome da Empresa:
                            </label>
                            <input
                                type="text"
                                id="clientName"
                                autoComplete="off"
                                defaultValue={client.nome}
                                onChange={(e) => setNome(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="dominioBitrix">
                                Domínio Bitrix:
                            </label>
                            <input
                                type="text"
                                id="dominioBitrix"
                                autoComplete="off"
                                defaultValue={client.dominio}
                                onChange={(e) => setDominio(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="webhookBitrix">
                                WebHook Bitrix:
                            </label>
                            <input
                                type="text"
                                id="webhookBitrix"
                                autoComplete="off"
                                defaultValue={client.webhook}
                                onChange={(e) => setWebhookBitrix(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="bitrixId">
                                ID Lista de Clientes:
                            </label>
                            <input
                                type="number"
                                id="bitrixId"
                                autoComplete="off"
                                defaultValue={client.idList}
                                onChange={(e) => setBitrixId(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="jiraMain">
                                Código Jira:
                            </label>
                            <input
                                type="text"
                                id="jiraMain"
                                autoComplete="off"
                                defaultValue={client.jiraMain}
                                onChange={(e) => setJiraMain(e.target.value)}
                                required
                            />
                        </SectionBox>

                        <SectionBox>
                            <label htmlFor="jiraSupport">
                                Código Suporte:
                            </label>
                            <input
                                type="text"
                                id="jiraSupport"
                                autoComplete="off"
                                defaultValue={client.jiraSupport}
                                onChange={(e) => setJiraSupport(e.target.value)}
                                required
                            />
                        </SectionBox>
                        <SendButtonContainer>
                            <SendButton
                                type='button'
                                onClick={handleSubmitButton}
                            >
                                Atualizar
                            </SendButton>
                        </SendButtonContainer>

                    </Form>


                </StyledContent>
            </Dialog.Portal>

        </Dialog.Root>
    )

}

export default UpdateClient;